import API from "../../..";
import { useQueryWrapper } from "../../wrappers";
import { devicesByRoomKey } from "../room-query-keys";

export function useQueryGetDevicesByRoom(roomId: string, enabled: boolean) {
  const { isLoading, data, isError } = useQueryWrapper({
    queryKey: devicesByRoomKey(roomId),
    queryFn: () => API.Rooms.getDevicesByRoom(roomId),
    enabled: enabled && !!roomId,
  });
  return {
    isLoading,
    devices: data || [],
    isError,
  };
}
